import { assert } from '@ember/debug';
import MacroServiceWrapper from '../~private/macro-service-wrapper';
/**
 * Computed property macro for checking a feature flag (similar to `computed.readOnly` from Ember).
 * @param {string} flag to check
 * @returns {boolean} whether the value of the flag is truthy
 */
export default function feature(...flags) {
  assert('this macro only takes one feature flag as an argument', flags.length === 1);
  const flag = flags[0];
  const dependentKeys = [`_flags.${flag}`];
  return MacroServiceWrapper(featuresServiceParam => featuresServiceParam.isEnabled(flag), dependentKeys);
}